'use client';
import React, { useEffect, useState } from 'react';
import { createClient } from '@/lib/supabase/client';

interface ChainConfig {
  chain_key: string;
  chain_name: string;
  chain_symbol: string;
  token_symbol: string;
  network_badge: string;
  chain_color: string;
  chain_icon: string;
  is_primary: boolean;
}

export default function ActiveChainIndicator() {
  const [chain, setChain] = useState<ChainConfig | null>(null);
  const [contractActive, setContractActive] = useState(false);

  useEffect(() => {
    const supabase = createClient();
    Promise.all([
      supabase.from('crypto_chain_config').select('*').eq('is_primary', true).single(),
      supabase.from('airdrop_smart_contract').select('id').eq('is_active', true).single(),
    ]).then((results) => {
      const { data: chainData, error: chainError } = results[0];
      const { data: contractData, error: contractError } = results[1];
      setChain(chainData || null);
      setContractActive(!!contractData);
    });
  }, []);

  if (!chain) return null;

  return (
    <div
      className="flex items-center gap-1.5 px-2 py-1 rounded-lg border text-xs font-medium"
      style={{
        background: `${chain.chain_color}12`,
        borderColor: `${chain.chain_color}30`,
        color: chain.chain_color,
      }}
      title={`${chain.chain_name} · ${chain.network_badge}`}
    >
      <span className="text-sm leading-none">{chain.chain_icon}</span>
      <span className="hidden sm:inline font-semibold">{chain.chain_symbol}</span>
      <span className="hidden md:inline text-[10px] opacity-80">{chain.network_badge}</span>
      {contractActive && (
        <span className="w-1.5 h-1.5 rounded-full bg-[#00E5A8] animate-pulse flex-shrink-0" title="Contract active" />
      )}
    </div>
  );
}
